import content from "app-content";

const getAfsFulfilmentStrings = ({
  seller: { description: sellerDescription }
}) => {
  const { afs_sold_by, afs_shipped_by_asos } = content;

  return { afs_sold_by, sellerDescription, afs_shipped_by_asos };
};

export default getAfsFulfilmentStrings;
